// This is proxy for being at the latest message. Tracking scroll positions
// in real-time is imprecise as new messages come in.
const VIEWING_LATEST_THRESHOLD = 0.9;

const MIN_INPUT_LENGTH = 2;

// configures WiseOwlChatLog to display the following date format for messages older
// than a day ago
const DATE_FORMAT_AFTER_YESTERDAY = "E, MMM dd yyyy hh:mm a";
const BASE_PROFILE = "SUPPORT_AGENT";

export {
  BASE_PROFILE,
  DATE_FORMAT_AFTER_YESTERDAY,
  MIN_INPUT_LENGTH,
  VIEWING_LATEST_THRESHOLD,
};
